module.exports = __webpack_public_path__ + "static/media/19_A.30b16374.png";